import { useState, useEffect } from "react";
import FormSelect from "../../../../components/Form/FormSelect";
import CheckboxField from "../../../../components/Form/CheckboxField";
import SystemValueForm from "../../../../components/SystemValue/SystemValueForm";

const CurrencyForm = ({ currencyToEdit, currencies, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    currencyId: "",
    active_flag: true,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (currencyToEdit) {
      setFormData({
        currencyId: currencyToEdit.currency_id,
        active_flag: currencyToEdit.active_flag,
      });
    } else {
      setFormData({ currencyId: "", active_flag: true });
    }
  }, [currencyToEdit]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.currencyId) {
      setErrors({ currencyId: "Currency is required." });
      return;
    }
    onSave(formData);
  };

  const currencyOptions = currencies.map((cur) => ({
    value: cur.id,
    label: `${cur.code} - ${cur.name}`,
  }));

  return (
    <SystemValueForm
      title={currencyToEdit ? "Edit Currency" : "Add Currency"}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    >
      <FormSelect
        label="Currency"
        name="currencyId"
        value={formData.currencyId}
        onChange={handleChange}
        options={currencyOptions}
        error={errors.currencyId}
        required
      />
      <CheckboxField
        label="Active"
        name="active_flag"
        checked={formData.active_flag}
        onChange={handleChange}
      />
    </SystemValueForm>
  );
};

export default CurrencyForm;
